import { render, staticRenderFns } from "./IbDateInput.vue?vue&type=template&id=28bd1408&scoped=true"
import script from "./IbDateInput.vue?vue&type=script&lang=js"
export * from "./IbDateInput.vue?vue&type=script&lang=js"
import style0 from "./IbDateInput.vue?vue&type=style&index=0&id=28bd1408&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd1408",
  null
  
)

export default component.exports